import { render, staticRenderFns } from "./sms-info.vue?vue&type=template&id=63973536&scoped=true"
import script from "./sms-info.vue?vue&type=script&lang=js"
export * from "./sms-info.vue?vue&type=script&lang=js"
import style0 from "./sms-info.vue?vue&type=style&index=0&id=63973536&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63973536",
  null
  
)

export default component.exports